import { render, staticRenderFns } from "./sampleReels.vue?vue&type=template&id=46ae92de&scoped=true&"
import script from "./sampleReels.vue?vue&type=script&lang=js&"
export * from "./sampleReels.vue?vue&type=script&lang=js&"
import style0 from "./sampleReels.vue?vue&type=style&index=0&id=46ae92de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ae92de",
  null
  
)

export default component.exports